import type { RealestateAsset } from "~/types/assets.types";
import type { Fiat } from "~/types/global.types";
import { calculateRealestateRentBase, calculateRealestateRentType } from "./rent";
import { calculateRealestateYearlySum } from "./yearlySum";

export const calculateRealestateNetYearlyIncome = (
  userProduct: RealestateAsset,
  baseCurrency: Fiat,
  currentCurrency: Fiat
) => {
    const rentBase = calculateRealestateRentBase(userProduct, baseCurrency, currentCurrency);
    const rentType = calculateRealestateRentType(userProduct);
    const yearlySum = calculateRealestateYearlySum(userProduct, baseCurrency, currentCurrency);

    return rentBase * rentType - yearlySum;
};
